import styled from "styled-components";

const excImg = require("../../assets/images/wallet/exc_credit.png");
const admImg = require("../../assets/images/wallet/adm_credit.png");
const goodImg = require("../../assets/images/wallet/good_credit.png");
const medImg = require("../../assets/images/wallet/med_credit.png");
const badImg = require("../../assets/images/wallet/bad_credit.png");

const Box = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  background: rgb(247, 248, 255);
`;

const Badge = styled.span<{ $bg: string; $border: string; $color: string }>`
  margin-left: 4px;
  padding: 1px 4px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 3px;
  border: 1px solid ${({ $border }) => $border};
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  white-space: nowrap;
`;

const CreditStatus = ({ credit_score }: { credit_score?: number }) => {
  const score = Number(credit_score) || 0;
  let img = excImg;
  let border = "rgb(51, 195, 65)";
  let bg = "rgb(199, 255, 221)";
  let text = " 信用极好 ";

  if (score >= 700) {
    // keep excellent
  } else if (score >= 650) {
    img = admImg;
    border = "rgb(28,156,234)";
    bg = "rgb(197,233,255)";
    text = " 信用优秀 ";
  } else if (score >= 600) {
    img = goodImg;
    border = "rgb(236,191,31)";
    bg = "rgb(255,246,215)";
    text = " 信用良好 ";
  } else if (score >= 550) {
    img = medImg;
    border = "rgb(236,154,31)";
    bg = "rgb(255,228,188)";
    text = " 信用中等 ";
  } else {
    img = badImg;
    border = "rgb(223,33,33)";
    bg = "rgb(255,224,224)";
    text = " 信用极差 ";
  }

  return (
    <Box>
      <img src={img} alt="" width={12} height={14} style={{ marginLeft: 4 }} />
      <Badge $bg={bg} $border={border} $color={border}>
        {text}
      </Badge>
    </Box>
  );
};

export default CreditStatus;
